module.exports = __webpack_public_path__ + "img/logo-index.7a8bebdf.png";